/* tslint:disable */
/* eslint-disable */
/**
 * InnerAnalytics MNT Server
 * InnerAnalytics MNT server API specification.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AppApiMealPlanPostEmailMealPlan200Response } from '../models';
// @ts-ignore
import { AppApiMealPlanPostSlotNoteRequest } from '../models';
// @ts-ignore
import { ClinicMealPlanSettingsRequest } from '../models';
// @ts-ignore
import { ClinicMealPlanSettingsResponse } from '../models';
// @ts-ignore
import { ConfirmIngredientSwapRequest } from '../models';
// @ts-ignore
import { CreateMealPlanRequest } from '../models';
// @ts-ignore
import { EmailMealPlanRequest } from '../models';
// @ts-ignore
import { GroceryListResponse } from '../models';
// @ts-ignore
import { MealPlanDetailResponse } from '../models';
// @ts-ignore
import { MealPlanResponse } from '../models';
// @ts-ignore
import { MealPlanSlotResponse } from '../models';
// @ts-ignore
import { MealPlanSummaryResponse } from '../models';
// @ts-ignore
import { SlotInstructionsResponse } from '../models';
// @ts-ignore
import { SwapConfirmRequest } from '../models';
// @ts-ignore
import { SwapIngredientRequest } from '../models';
// @ts-ignore
import { SwapIngredientResponse } from '../models';
// @ts-ignore
import { SwapRecipeRequest } from '../models';
// @ts-ignore
import { SwapRecipeResponse } from '../models';
// @ts-ignore
import { SwapSuggestionsRequest } from '../models';
// @ts-ignore
import { SwapSuggestionsResponse } from '../models';
// @ts-ignore
import { TaskResultResponse } from '../models';
// @ts-ignore
import { TdeeCalculateRequest } from '../models';
// @ts-ignore
import { TdeeCalculateResponse } from '../models';
/**
 * MealPlanApi - axios parameter creator
 * @export
 */
export const MealPlanApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Soft-delete a meal plan
         * @param {number} patient_id 
         * @param {number} meal_plan_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiMealPlanDeleteMealPlan: async (patient_id: number, meal_plan_id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patient_id' is not null or undefined
            assertParamExists('appApiMealPlanDeleteMealPlan', 'patient_id', patient_id)
            // verify required parameter 'meal_plan_id' is not null or undefined
            assertParamExists('appApiMealPlanDeleteMealPlan', 'meal_plan_id', meal_plan_id)
            const localVarPath = `/patients/{patient_id}/meal-plans/{meal_plan_id}`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patient_id)))
                .replace(`{${"meal_plan_id"}}`, encodeURIComponent(String(meal_plan_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get meal plan settings for a clinic
         * @param {number} clinic_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiMealPlanGetClinicMealPlanSettings: async (clinic_id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clinic_id' is not null or undefined
            assertParamExists('appApiMealPlanGetClinicMealPlanSettings', 'clinic_id', clinic_id)
            const localVarPath = `/clinics/{clinic_id}/meal-plan-settings`
                .replace(`{${"clinic_id"}}`, encodeURIComponent(String(clinic_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a specific meal plan with days and slots
         * @param {number} patient_id 
         * @param {number} meal_plan_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiMealPlanGetMealPlan: async (patient_id: number, meal_plan_id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patient_id' is not null or undefined
            assertParamExists('appApiMealPlanGetMealPlan', 'patient_id', patient_id)
            // verify required parameter 'meal_plan_id' is not null or undefined
            assertParamExists('appApiMealPlanGetMealPlan', 'meal_plan_id', meal_plan_id)
            const localVarPath = `/patients/{patient_id}/meal-plans/{meal_plan_id}`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patient_id)))
                .replace(`{${"meal_plan_id"}}`, encodeURIComponent(String(meal_plan_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List meal plans for the patient
         * @param {number} patient_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiMealPlanGetMealPlans: async (patient_id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patient_id' is not null or undefined
            assertParamExists('appApiMealPlanGetMealPlans', 'patient_id', patient_id)
            const localVarPath = `/patients/{patient_id}/meal-plans`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patient_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get recipe instructions for a meal plan slot
         * @param {number} patient_id 
         * @param {number} meal_plan_id 
         * @param {number} slot_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiMealPlanGetSlotInstructions: async (patient_id: number, meal_plan_id: number, slot_id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patient_id' is not null or undefined
            assertParamExists('appApiMealPlanGetSlotInstructions', 'patient_id', patient_id)
            // verify required parameter 'meal_plan_id' is not null or undefined
            assertParamExists('appApiMealPlanGetSlotInstructions', 'meal_plan_id', meal_plan_id)
            // verify required parameter 'slot_id' is not null or undefined
            assertParamExists('appApiMealPlanGetSlotInstructions', 'slot_id', slot_id)
            const localVarPath = `/patients/{patient_id}/meal-plans/{meal_plan_id}/slots/{slot_id}/instructions`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patient_id)))
                .replace(`{${"meal_plan_id"}}`, encodeURIComponent(String(meal_plan_id)))
                .replace(`{${"slot_id"}}`, encodeURIComponent(String(slot_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Confirm an ingredient swap in a meal plan slot
         * @param {number} patient_id 
         * @param {number} meal_plan_id 
         * @param {ConfirmIngredientSwapRequest} ConfirmIngredientSwapRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiMealPlanPostConfirmIngredientSwap: async (patient_id: number, meal_plan_id: number, ConfirmIngredientSwapRequest: ConfirmIngredientSwapRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patient_id' is not null or undefined
            assertParamExists('appApiMealPlanPostConfirmIngredientSwap', 'patient_id', patient_id)
            // verify required parameter 'meal_plan_id' is not null or undefined
            assertParamExists('appApiMealPlanPostConfirmIngredientSwap', 'meal_plan_id', meal_plan_id)
            // verify required parameter 'ConfirmIngredientSwapRequest' is not null or undefined
            assertParamExists('appApiMealPlanPostConfirmIngredientSwap', 'ConfirmIngredientSwapRequest', ConfirmIngredientSwapRequest)
            const localVarPath = `/patients/{patient_id}/meal-plans/{meal_plan_id}/confirm-ingredient-swap`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patient_id)))
                .replace(`{${"meal_plan_id"}}`, encodeURIComponent(String(meal_plan_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ConfirmIngredientSwapRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Duplicate a meal plan as a new draft
         * @param {number} patient_id 
         * @param {number} meal_plan_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiMealPlanPostDuplicateMealPlan: async (patient_id: number, meal_plan_id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patient_id' is not null or undefined
            assertParamExists('appApiMealPlanPostDuplicateMealPlan', 'patient_id', patient_id)
            // verify required parameter 'meal_plan_id' is not null or undefined
            assertParamExists('appApiMealPlanPostDuplicateMealPlan', 'meal_plan_id', meal_plan_id)
            const localVarPath = `/patients/{patient_id}/meal-plans/{meal_plan_id}/duplicate`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patient_id)))
                .replace(`{${"meal_plan_id"}}`, encodeURIComponent(String(meal_plan_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Email a meal plan to the patient
         * @param {number} patient_id 
         * @param {number} meal_plan_id 
         * @param {EmailMealPlanRequest} [EmailMealPlanRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiMealPlanPostEmailMealPlan: async (patient_id: number, meal_plan_id: number, EmailMealPlanRequest?: EmailMealPlanRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patient_id' is not null or undefined
            assertParamExists('appApiMealPlanPostEmailMealPlan', 'patient_id', patient_id)
            // verify required parameter 'meal_plan_id' is not null or undefined
            assertParamExists('appApiMealPlanPostEmailMealPlan', 'meal_plan_id', meal_plan_id)
            const localVarPath = `/patients/{patient_id}/meal-plans/{meal_plan_id}/email`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patient_id)))
                .replace(`{${"meal_plan_id"}}`, encodeURIComponent(String(meal_plan_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EmailMealPlanRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Finalize a generated meal plan
         * @param {number} patient_id 
         * @param {number} meal_plan_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiMealPlanPostFinalizeMealPlan: async (patient_id: number, meal_plan_id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patient_id' is not null or undefined
            assertParamExists('appApiMealPlanPostFinalizeMealPlan', 'patient_id', patient_id)
            // verify required parameter 'meal_plan_id' is not null or undefined
            assertParamExists('appApiMealPlanPostFinalizeMealPlan', 'meal_plan_id', meal_plan_id)
            const localVarPath = `/patients/{patient_id}/meal-plans/{meal_plan_id}/finalize`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patient_id)))
                .replace(`{${"meal_plan_id"}}`, encodeURIComponent(String(meal_plan_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generate meal plan content using AI
         * @param {number} patient_id 
         * @param {number} meal_plan_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiMealPlanPostGenerateMealPlan: async (patient_id: number, meal_plan_id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patient_id' is not null or undefined
            assertParamExists('appApiMealPlanPostGenerateMealPlan', 'patient_id', patient_id)
            // verify required parameter 'meal_plan_id' is not null or undefined
            assertParamExists('appApiMealPlanPostGenerateMealPlan', 'meal_plan_id', meal_plan_id)
            const localVarPath = `/patients/{patient_id}/meal-plans/{meal_plan_id}/generate`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patient_id)))
                .replace(`{${"meal_plan_id"}}`, encodeURIComponent(String(meal_plan_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generate a grocery list for a meal plan
         * @param {number} patient_id 
         * @param {number} meal_plan_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiMealPlanPostGroceryList: async (patient_id: number, meal_plan_id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patient_id' is not null or undefined
            assertParamExists('appApiMealPlanPostGroceryList', 'patient_id', patient_id)
            // verify required parameter 'meal_plan_id' is not null or undefined
            assertParamExists('appApiMealPlanPostGroceryList', 'meal_plan_id', meal_plan_id)
            const localVarPath = `/patients/{patient_id}/meal-plans/{meal_plan_id}/grocery-list`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patient_id)))
                .replace(`{${"meal_plan_id"}}`, encodeURIComponent(String(meal_plan_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new meal plan for the patient
         * @param {number} patient_id 
         * @param {CreateMealPlanRequest} CreateMealPlanRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiMealPlanPostMealPlan: async (patient_id: number, CreateMealPlanRequest: CreateMealPlanRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patient_id' is not null or undefined
            assertParamExists('appApiMealPlanPostMealPlan', 'patient_id', patient_id)
            // verify required parameter 'CreateMealPlanRequest' is not null or undefined
            assertParamExists('appApiMealPlanPostMealPlan', 'CreateMealPlanRequest', CreateMealPlanRequest)
            const localVarPath = `/patients/{patient_id}/meal-plans`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patient_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CreateMealPlanRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generate a PDF for a meal plan
         * @param {number} patient_id 
         * @param {number} meal_plan_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiMealPlanPostMealPlanPdf: async (patient_id: number, meal_plan_id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patient_id' is not null or undefined
            assertParamExists('appApiMealPlanPostMealPlanPdf', 'patient_id', patient_id)
            // verify required parameter 'meal_plan_id' is not null or undefined
            assertParamExists('appApiMealPlanPostMealPlanPdf', 'meal_plan_id', meal_plan_id)
            const localVarPath = `/patients/{patient_id}/meal-plans/{meal_plan_id}/pdf`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patient_id)))
                .replace(`{${"meal_plan_id"}}`, encodeURIComponent(String(meal_plan_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add or update a clinician note on a meal plan slot
         * @param {number} patient_id 
         * @param {number} meal_plan_id 
         * @param {number} slot_id 
         * @param {AppApiMealPlanPostSlotNoteRequest} AppApiMealPlanPostSlotNoteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiMealPlanPostSlotNote: async (patient_id: number, meal_plan_id: number, slot_id: number, AppApiMealPlanPostSlotNoteRequest: AppApiMealPlanPostSlotNoteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patient_id' is not null or undefined
            assertParamExists('appApiMealPlanPostSlotNote', 'patient_id', patient_id)
            // verify required parameter 'meal_plan_id' is not null or undefined
            assertParamExists('appApiMealPlanPostSlotNote', 'meal_plan_id', meal_plan_id)
            // verify required parameter 'slot_id' is not null or undefined
            assertParamExists('appApiMealPlanPostSlotNote', 'slot_id', slot_id)
            // verify required parameter 'AppApiMealPlanPostSlotNoteRequest' is not null or undefined
            assertParamExists('appApiMealPlanPostSlotNote', 'AppApiMealPlanPostSlotNoteRequest', AppApiMealPlanPostSlotNoteRequest)
            const localVarPath = `/patients/{patient_id}/meal-plans/{meal_plan_id}/slots/{slot_id}/note`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patient_id)))
                .replace(`{${"meal_plan_id"}}`, encodeURIComponent(String(meal_plan_id)))
                .replace(`{${"slot_id"}}`, encodeURIComponent(String(slot_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(AppApiMealPlanPostSlotNoteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Confirm a recipe swap in a meal plan slot
         * @param {number} patient_id 
         * @param {number} meal_plan_id 
         * @param {SwapConfirmRequest} SwapConfirmRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiMealPlanPostSwapConfirm: async (patient_id: number, meal_plan_id: number, SwapConfirmRequest: SwapConfirmRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patient_id' is not null or undefined
            assertParamExists('appApiMealPlanPostSwapConfirm', 'patient_id', patient_id)
            // verify required parameter 'meal_plan_id' is not null or undefined
            assertParamExists('appApiMealPlanPostSwapConfirm', 'meal_plan_id', meal_plan_id)
            // verify required parameter 'SwapConfirmRequest' is not null or undefined
            assertParamExists('appApiMealPlanPostSwapConfirm', 'SwapConfirmRequest', SwapConfirmRequest)
            const localVarPath = `/patients/{patient_id}/meal-plans/{meal_plan_id}/swap-confirm`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patient_id)))
                .replace(`{${"meal_plan_id"}}`, encodeURIComponent(String(meal_plan_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(SwapConfirmRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get ingredient swap suggestions for a meal plan slot
         * @param {number} patient_id 
         * @param {number} meal_plan_id 
         * @param {SwapIngredientRequest} SwapIngredientRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiMealPlanPostSwapIngredient: async (patient_id: number, meal_plan_id: number, SwapIngredientRequest: SwapIngredientRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patient_id' is not null or undefined
            assertParamExists('appApiMealPlanPostSwapIngredient', 'patient_id', patient_id)
            // verify required parameter 'meal_plan_id' is not null or undefined
            assertParamExists('appApiMealPlanPostSwapIngredient', 'meal_plan_id', meal_plan_id)
            // verify required parameter 'SwapIngredientRequest' is not null or undefined
            assertParamExists('appApiMealPlanPostSwapIngredient', 'SwapIngredientRequest', SwapIngredientRequest)
            const localVarPath = `/patients/{patient_id}/meal-plans/{meal_plan_id}/swap-ingredient`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patient_id)))
                .replace(`{${"meal_plan_id"}}`, encodeURIComponent(String(meal_plan_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(SwapIngredientRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Swap a recipe in a meal plan slot
         * @param {number} patient_id 
         * @param {number} meal_plan_id 
         * @param {SwapRecipeRequest} SwapRecipeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiMealPlanPostSwapRecipe: async (patient_id: number, meal_plan_id: number, SwapRecipeRequest: SwapRecipeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patient_id' is not null or undefined
            assertParamExists('appApiMealPlanPostSwapRecipe', 'patient_id', patient_id)
            // verify required parameter 'meal_plan_id' is not null or undefined
            assertParamExists('appApiMealPlanPostSwapRecipe', 'meal_plan_id', meal_plan_id)
            // verify required parameter 'SwapRecipeRequest' is not null or undefined
            assertParamExists('appApiMealPlanPostSwapRecipe', 'SwapRecipeRequest', SwapRecipeRequest)
            const localVarPath = `/patients/{patient_id}/meal-plans/{meal_plan_id}/swap`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patient_id)))
                .replace(`{${"meal_plan_id"}}`, encodeURIComponent(String(meal_plan_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(SwapRecipeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get swap recipe suggestions for a meal plan slot
         * @param {number} patient_id 
         * @param {number} meal_plan_id 
         * @param {SwapSuggestionsRequest} SwapSuggestionsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiMealPlanPostSwapSuggestions: async (patient_id: number, meal_plan_id: number, SwapSuggestionsRequest: SwapSuggestionsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patient_id' is not null or undefined
            assertParamExists('appApiMealPlanPostSwapSuggestions', 'patient_id', patient_id)
            // verify required parameter 'meal_plan_id' is not null or undefined
            assertParamExists('appApiMealPlanPostSwapSuggestions', 'meal_plan_id', meal_plan_id)
            // verify required parameter 'SwapSuggestionsRequest' is not null or undefined
            assertParamExists('appApiMealPlanPostSwapSuggestions', 'SwapSuggestionsRequest', SwapSuggestionsRequest)
            const localVarPath = `/patients/{patient_id}/meal-plans/{meal_plan_id}/swap-suggestions`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patient_id)))
                .replace(`{${"meal_plan_id"}}`, encodeURIComponent(String(meal_plan_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(SwapSuggestionsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Calculate TDEE for a patient
         * @param {number} patient_id 
         * @param {TdeeCalculateRequest} TdeeCalculateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiMealPlanPostTdeeCalculate: async (patient_id: number, TdeeCalculateRequest: TdeeCalculateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patient_id' is not null or undefined
            assertParamExists('appApiMealPlanPostTdeeCalculate', 'patient_id', patient_id)
            // verify required parameter 'TdeeCalculateRequest' is not null or undefined
            assertParamExists('appApiMealPlanPostTdeeCalculate', 'TdeeCalculateRequest', TdeeCalculateRequest)
            const localVarPath = `/patients/{patient_id}/meal-plans/tdee-calculate`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patient_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(TdeeCalculateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update meal plan settings for a clinic
         * @param {number} clinic_id 
         * @param {ClinicMealPlanSettingsRequest} ClinicMealPlanSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiMealPlanPutClinicMealPlanSettings: async (clinic_id: number, ClinicMealPlanSettingsRequest: ClinicMealPlanSettingsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clinic_id' is not null or undefined
            assertParamExists('appApiMealPlanPutClinicMealPlanSettings', 'clinic_id', clinic_id)
            // verify required parameter 'ClinicMealPlanSettingsRequest' is not null or undefined
            assertParamExists('appApiMealPlanPutClinicMealPlanSettings', 'ClinicMealPlanSettingsRequest', ClinicMealPlanSettingsRequest)
            const localVarPath = `/clinics/{clinic_id}/meal-plan-settings`
                .replace(`{${"clinic_id"}}`, encodeURIComponent(String(clinic_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ClinicMealPlanSettingsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MealPlanApi - functional programming interface
 * @export
 */
export const MealPlanApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MealPlanApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Soft-delete a meal plan
         * @param {number} patient_id 
         * @param {number} meal_plan_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appApiMealPlanDeleteMealPlan(patient_id: number, meal_plan_id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appApiMealPlanDeleteMealPlan(patient_id, meal_plan_id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get meal plan settings for a clinic
         * @param {number} clinic_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appApiMealPlanGetClinicMealPlanSettings(clinic_id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClinicMealPlanSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appApiMealPlanGetClinicMealPlanSettings(clinic_id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a specific meal plan with days and slots
         * @param {number} patient_id 
         * @param {number} meal_plan_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appApiMealPlanGetMealPlan(patient_id: number, meal_plan_id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MealPlanDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appApiMealPlanGetMealPlan(patient_id, meal_plan_id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List meal plans for the patient
         * @param {number} patient_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appApiMealPlanGetMealPlans(patient_id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MealPlanSummaryResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appApiMealPlanGetMealPlans(patient_id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get recipe instructions for a meal plan slot
         * @param {number} patient_id 
         * @param {number} meal_plan_id 
         * @param {number} slot_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appApiMealPlanGetSlotInstructions(patient_id: number, meal_plan_id: number, slot_id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SlotInstructionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appApiMealPlanGetSlotInstructions(patient_id, meal_plan_id, slot_id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Confirm an ingredient swap in a meal plan slot
         * @param {number} patient_id 
         * @param {number} meal_plan_id 
         * @param {ConfirmIngredientSwapRequest} ConfirmIngredientSwapRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appApiMealPlanPostConfirmIngredientSwap(patient_id: number, meal_plan_id: number, ConfirmIngredientSwapRequest: ConfirmIngredientSwapRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MealPlanSlotResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appApiMealPlanPostConfirmIngredientSwap(patient_id, meal_plan_id, ConfirmIngredientSwapRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Duplicate a meal plan as a new draft
         * @param {number} patient_id 
         * @param {number} meal_plan_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appApiMealPlanPostDuplicateMealPlan(patient_id: number, meal_plan_id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MealPlanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appApiMealPlanPostDuplicateMealPlan(patient_id, meal_plan_id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Email a meal plan to the patient
         * @param {number} patient_id 
         * @param {number} meal_plan_id 
         * @param {EmailMealPlanRequest} [EmailMealPlanRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appApiMealPlanPostEmailMealPlan(patient_id: number, meal_plan_id: number, EmailMealPlanRequest?: EmailMealPlanRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppApiMealPlanPostEmailMealPlan200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appApiMealPlanPostEmailMealPlan(patient_id, meal_plan_id, EmailMealPlanRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Finalize a generated meal plan
         * @param {number} patient_id 
         * @param {number} meal_plan_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appApiMealPlanPostFinalizeMealPlan(patient_id: number, meal_plan_id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MealPlanDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appApiMealPlanPostFinalizeMealPlan(patient_id, meal_plan_id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Generate meal plan content using AI
         * @param {number} patient_id 
         * @param {number} meal_plan_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appApiMealPlanPostGenerateMealPlan(patient_id: number, meal_plan_id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskResultResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appApiMealPlanPostGenerateMealPlan(patient_id, meal_plan_id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Generate a grocery list for a meal plan
         * @param {number} patient_id 
         * @param {number} meal_plan_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appApiMealPlanPostGroceryList(patient_id: number, meal_plan_id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroceryListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appApiMealPlanPostGroceryList(patient_id, meal_plan_id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a new meal plan for the patient
         * @param {number} patient_id 
         * @param {CreateMealPlanRequest} CreateMealPlanRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appApiMealPlanPostMealPlan(patient_id: number, CreateMealPlanRequest: CreateMealPlanRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MealPlanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appApiMealPlanPostMealPlan(patient_id, CreateMealPlanRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Generate a PDF for a meal plan
         * @param {number} patient_id 
         * @param {number} meal_plan_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appApiMealPlanPostMealPlanPdf(patient_id: number, meal_plan_id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appApiMealPlanPostMealPlanPdf(patient_id, meal_plan_id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Add or update a clinician note on a meal plan slot
         * @param {number} patient_id 
         * @param {number} meal_plan_id 
         * @param {number} slot_id 
         * @param {AppApiMealPlanPostSlotNoteRequest} AppApiMealPlanPostSlotNoteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appApiMealPlanPostSlotNote(patient_id: number, meal_plan_id: number, slot_id: number, AppApiMealPlanPostSlotNoteRequest: AppApiMealPlanPostSlotNoteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appApiMealPlanPostSlotNote(patient_id, meal_plan_id, slot_id, AppApiMealPlanPostSlotNoteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Confirm a recipe swap in a meal plan slot
         * @param {number} patient_id 
         * @param {number} meal_plan_id 
         * @param {SwapConfirmRequest} SwapConfirmRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appApiMealPlanPostSwapConfirm(patient_id: number, meal_plan_id: number, SwapConfirmRequest: SwapConfirmRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SwapRecipeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appApiMealPlanPostSwapConfirm(patient_id, meal_plan_id, SwapConfirmRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get ingredient swap suggestions for a meal plan slot
         * @param {number} patient_id 
         * @param {number} meal_plan_id 
         * @param {SwapIngredientRequest} SwapIngredientRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appApiMealPlanPostSwapIngredient(patient_id: number, meal_plan_id: number, SwapIngredientRequest: SwapIngredientRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SwapIngredientResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appApiMealPlanPostSwapIngredient(patient_id, meal_plan_id, SwapIngredientRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Swap a recipe in a meal plan slot
         * @param {number} patient_id 
         * @param {number} meal_plan_id 
         * @param {SwapRecipeRequest} SwapRecipeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appApiMealPlanPostSwapRecipe(patient_id: number, meal_plan_id: number, SwapRecipeRequest: SwapRecipeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SwapRecipeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appApiMealPlanPostSwapRecipe(patient_id, meal_plan_id, SwapRecipeRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get swap recipe suggestions for a meal plan slot
         * @param {number} patient_id 
         * @param {number} meal_plan_id 
         * @param {SwapSuggestionsRequest} SwapSuggestionsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appApiMealPlanPostSwapSuggestions(patient_id: number, meal_plan_id: number, SwapSuggestionsRequest: SwapSuggestionsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SwapSuggestionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appApiMealPlanPostSwapSuggestions(patient_id, meal_plan_id, SwapSuggestionsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Calculate TDEE for a patient
         * @param {number} patient_id 
         * @param {TdeeCalculateRequest} TdeeCalculateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appApiMealPlanPostTdeeCalculate(patient_id: number, TdeeCalculateRequest: TdeeCalculateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TdeeCalculateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appApiMealPlanPostTdeeCalculate(patient_id, TdeeCalculateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update meal plan settings for a clinic
         * @param {number} clinic_id 
         * @param {ClinicMealPlanSettingsRequest} ClinicMealPlanSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appApiMealPlanPutClinicMealPlanSettings(clinic_id: number, ClinicMealPlanSettingsRequest: ClinicMealPlanSettingsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClinicMealPlanSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appApiMealPlanPutClinicMealPlanSettings(clinic_id, ClinicMealPlanSettingsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MealPlanApi - factory interface
 * @export
 */
export const MealPlanApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MealPlanApiFp(configuration)
    return {
        /**
         * 
         * @summary Soft-delete a meal plan
         * @param {MealPlanApiAppApiMealPlanDeleteMealPlanRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiMealPlanDeleteMealPlan(requestParameters: MealPlanApiAppApiMealPlanDeleteMealPlanRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.appApiMealPlanDeleteMealPlan(requestParameters.patient_id, requestParameters.meal_plan_id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get meal plan settings for a clinic
         * @param {MealPlanApiAppApiMealPlanGetClinicMealPlanSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiMealPlanGetClinicMealPlanSettings(requestParameters: MealPlanApiAppApiMealPlanGetClinicMealPlanSettingsRequest, options?: AxiosRequestConfig): AxiosPromise<ClinicMealPlanSettingsResponse> {
            return localVarFp.appApiMealPlanGetClinicMealPlanSettings(requestParameters.clinic_id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a specific meal plan with days and slots
         * @param {MealPlanApiAppApiMealPlanGetMealPlanRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiMealPlanGetMealPlan(requestParameters: MealPlanApiAppApiMealPlanGetMealPlanRequest, options?: AxiosRequestConfig): AxiosPromise<MealPlanDetailResponse> {
            return localVarFp.appApiMealPlanGetMealPlan(requestParameters.patient_id, requestParameters.meal_plan_id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List meal plans for the patient
         * @param {MealPlanApiAppApiMealPlanGetMealPlansRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiMealPlanGetMealPlans(requestParameters: MealPlanApiAppApiMealPlanGetMealPlansRequest, options?: AxiosRequestConfig): AxiosPromise<Array<MealPlanSummaryResponse>> {
            return localVarFp.appApiMealPlanGetMealPlans(requestParameters.patient_id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get recipe instructions for a meal plan slot
         * @param {MealPlanApiAppApiMealPlanGetSlotInstructionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiMealPlanGetSlotInstructions(requestParameters: MealPlanApiAppApiMealPlanGetSlotInstructionsRequest, options?: AxiosRequestConfig): AxiosPromise<SlotInstructionsResponse> {
            return localVarFp.appApiMealPlanGetSlotInstructions(requestParameters.patient_id, requestParameters.meal_plan_id, requestParameters.slot_id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Confirm an ingredient swap in a meal plan slot
         * @param {MealPlanApiAppApiMealPlanPostConfirmIngredientSwapRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiMealPlanPostConfirmIngredientSwap(requestParameters: MealPlanApiAppApiMealPlanPostConfirmIngredientSwapRequest, options?: AxiosRequestConfig): AxiosPromise<MealPlanSlotResponse> {
            return localVarFp.appApiMealPlanPostConfirmIngredientSwap(requestParameters.patient_id, requestParameters.meal_plan_id, requestParameters.ConfirmIngredientSwapRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Duplicate a meal plan as a new draft
         * @param {MealPlanApiAppApiMealPlanPostDuplicateMealPlanRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiMealPlanPostDuplicateMealPlan(requestParameters: MealPlanApiAppApiMealPlanPostDuplicateMealPlanRequest, options?: AxiosRequestConfig): AxiosPromise<MealPlanResponse> {
            return localVarFp.appApiMealPlanPostDuplicateMealPlan(requestParameters.patient_id, requestParameters.meal_plan_id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Email a meal plan to the patient
         * @param {MealPlanApiAppApiMealPlanPostEmailMealPlanRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiMealPlanPostEmailMealPlan(requestParameters: MealPlanApiAppApiMealPlanPostEmailMealPlanRequest, options?: AxiosRequestConfig): AxiosPromise<AppApiMealPlanPostEmailMealPlan200Response> {
            return localVarFp.appApiMealPlanPostEmailMealPlan(requestParameters.patient_id, requestParameters.meal_plan_id, requestParameters.EmailMealPlanRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Finalize a generated meal plan
         * @param {MealPlanApiAppApiMealPlanPostFinalizeMealPlanRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiMealPlanPostFinalizeMealPlan(requestParameters: MealPlanApiAppApiMealPlanPostFinalizeMealPlanRequest, options?: AxiosRequestConfig): AxiosPromise<MealPlanDetailResponse> {
            return localVarFp.appApiMealPlanPostFinalizeMealPlan(requestParameters.patient_id, requestParameters.meal_plan_id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generate meal plan content using AI
         * @param {MealPlanApiAppApiMealPlanPostGenerateMealPlanRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiMealPlanPostGenerateMealPlan(requestParameters: MealPlanApiAppApiMealPlanPostGenerateMealPlanRequest, options?: AxiosRequestConfig): AxiosPromise<TaskResultResponse> {
            return localVarFp.appApiMealPlanPostGenerateMealPlan(requestParameters.patient_id, requestParameters.meal_plan_id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generate a grocery list for a meal plan
         * @param {MealPlanApiAppApiMealPlanPostGroceryListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiMealPlanPostGroceryList(requestParameters: MealPlanApiAppApiMealPlanPostGroceryListRequest, options?: AxiosRequestConfig): AxiosPromise<GroceryListResponse> {
            return localVarFp.appApiMealPlanPostGroceryList(requestParameters.patient_id, requestParameters.meal_plan_id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new meal plan for the patient
         * @param {MealPlanApiAppApiMealPlanPostMealPlanRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiMealPlanPostMealPlan(requestParameters: MealPlanApiAppApiMealPlanPostMealPlanRequest, options?: AxiosRequestConfig): AxiosPromise<MealPlanResponse> {
            return localVarFp.appApiMealPlanPostMealPlan(requestParameters.patient_id, requestParameters.CreateMealPlanRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generate a PDF for a meal plan
         * @param {MealPlanApiAppApiMealPlanPostMealPlanPdfRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiMealPlanPostMealPlanPdf(requestParameters: MealPlanApiAppApiMealPlanPostMealPlanPdfRequest, options?: AxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.appApiMealPlanPostMealPlanPdf(requestParameters.patient_id, requestParameters.meal_plan_id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add or update a clinician note on a meal plan slot
         * @param {MealPlanApiAppApiMealPlanPostSlotNoteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiMealPlanPostSlotNote(requestParameters: MealPlanApiAppApiMealPlanPostSlotNoteRequest, options?: AxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.appApiMealPlanPostSlotNote(requestParameters.patient_id, requestParameters.meal_plan_id, requestParameters.slot_id, requestParameters.AppApiMealPlanPostSlotNoteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Confirm a recipe swap in a meal plan slot
         * @param {MealPlanApiAppApiMealPlanPostSwapConfirmRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiMealPlanPostSwapConfirm(requestParameters: MealPlanApiAppApiMealPlanPostSwapConfirmRequest, options?: AxiosRequestConfig): AxiosPromise<SwapRecipeResponse> {
            return localVarFp.appApiMealPlanPostSwapConfirm(requestParameters.patient_id, requestParameters.meal_plan_id, requestParameters.SwapConfirmRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get ingredient swap suggestions for a meal plan slot
         * @param {MealPlanApiAppApiMealPlanPostSwapIngredientRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiMealPlanPostSwapIngredient(requestParameters: MealPlanApiAppApiMealPlanPostSwapIngredientRequest, options?: AxiosRequestConfig): AxiosPromise<SwapIngredientResponse> {
            return localVarFp.appApiMealPlanPostSwapIngredient(requestParameters.patient_id, requestParameters.meal_plan_id, requestParameters.SwapIngredientRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Swap a recipe in a meal plan slot
         * @param {MealPlanApiAppApiMealPlanPostSwapRecipeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiMealPlanPostSwapRecipe(requestParameters: MealPlanApiAppApiMealPlanPostSwapRecipeRequest, options?: AxiosRequestConfig): AxiosPromise<SwapRecipeResponse> {
            return localVarFp.appApiMealPlanPostSwapRecipe(requestParameters.patient_id, requestParameters.meal_plan_id, requestParameters.SwapRecipeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get swap recipe suggestions for a meal plan slot
         * @param {MealPlanApiAppApiMealPlanPostSwapSuggestionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiMealPlanPostSwapSuggestions(requestParameters: MealPlanApiAppApiMealPlanPostSwapSuggestionsRequest, options?: AxiosRequestConfig): AxiosPromise<SwapSuggestionsResponse> {
            return localVarFp.appApiMealPlanPostSwapSuggestions(requestParameters.patient_id, requestParameters.meal_plan_id, requestParameters.SwapSuggestionsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Calculate TDEE for a patient
         * @param {MealPlanApiAppApiMealPlanPostTdeeCalculateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiMealPlanPostTdeeCalculate(requestParameters: MealPlanApiAppApiMealPlanPostTdeeCalculateRequest, options?: AxiosRequestConfig): AxiosPromise<TdeeCalculateResponse> {
            return localVarFp.appApiMealPlanPostTdeeCalculate(requestParameters.patient_id, requestParameters.TdeeCalculateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update meal plan settings for a clinic
         * @param {MealPlanApiAppApiMealPlanPutClinicMealPlanSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiMealPlanPutClinicMealPlanSettings(requestParameters: MealPlanApiAppApiMealPlanPutClinicMealPlanSettingsRequest, options?: AxiosRequestConfig): AxiosPromise<ClinicMealPlanSettingsResponse> {
            return localVarFp.appApiMealPlanPutClinicMealPlanSettings(requestParameters.clinic_id, requestParameters.ClinicMealPlanSettingsRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for appApiMealPlanDeleteMealPlan operation in MealPlanApi.
 * @export
 * @interface MealPlanApiAppApiMealPlanDeleteMealPlanRequest
 */
export interface MealPlanApiAppApiMealPlanDeleteMealPlanRequest {
    /**
     * 
     * @type {number}
     * @memberof MealPlanApiAppApiMealPlanDeleteMealPlan
     */
    readonly patient_id: number

    /**
     * 
     * @type {number}
     * @memberof MealPlanApiAppApiMealPlanDeleteMealPlan
     */
    readonly meal_plan_id: number
}

/**
 * Request parameters for appApiMealPlanGetClinicMealPlanSettings operation in MealPlanApi.
 * @export
 * @interface MealPlanApiAppApiMealPlanGetClinicMealPlanSettingsRequest
 */
export interface MealPlanApiAppApiMealPlanGetClinicMealPlanSettingsRequest {
    /**
     * 
     * @type {number}
     * @memberof MealPlanApiAppApiMealPlanGetClinicMealPlanSettings
     */
    readonly clinic_id: number
}

/**
 * Request parameters for appApiMealPlanGetMealPlan operation in MealPlanApi.
 * @export
 * @interface MealPlanApiAppApiMealPlanGetMealPlanRequest
 */
export interface MealPlanApiAppApiMealPlanGetMealPlanRequest {
    /**
     * 
     * @type {number}
     * @memberof MealPlanApiAppApiMealPlanGetMealPlan
     */
    readonly patient_id: number

    /**
     * 
     * @type {number}
     * @memberof MealPlanApiAppApiMealPlanGetMealPlan
     */
    readonly meal_plan_id: number
}

/**
 * Request parameters for appApiMealPlanGetMealPlans operation in MealPlanApi.
 * @export
 * @interface MealPlanApiAppApiMealPlanGetMealPlansRequest
 */
export interface MealPlanApiAppApiMealPlanGetMealPlansRequest {
    /**
     * 
     * @type {number}
     * @memberof MealPlanApiAppApiMealPlanGetMealPlans
     */
    readonly patient_id: number
}

/**
 * Request parameters for appApiMealPlanGetSlotInstructions operation in MealPlanApi.
 * @export
 * @interface MealPlanApiAppApiMealPlanGetSlotInstructionsRequest
 */
export interface MealPlanApiAppApiMealPlanGetSlotInstructionsRequest {
    /**
     * 
     * @type {number}
     * @memberof MealPlanApiAppApiMealPlanGetSlotInstructions
     */
    readonly patient_id: number

    /**
     * 
     * @type {number}
     * @memberof MealPlanApiAppApiMealPlanGetSlotInstructions
     */
    readonly meal_plan_id: number

    /**
     * 
     * @type {number}
     * @memberof MealPlanApiAppApiMealPlanGetSlotInstructions
     */
    readonly slot_id: number
}

/**
 * Request parameters for appApiMealPlanPostConfirmIngredientSwap operation in MealPlanApi.
 * @export
 * @interface MealPlanApiAppApiMealPlanPostConfirmIngredientSwapRequest
 */
export interface MealPlanApiAppApiMealPlanPostConfirmIngredientSwapRequest {
    /**
     * 
     * @type {number}
     * @memberof MealPlanApiAppApiMealPlanPostConfirmIngredientSwap
     */
    readonly patient_id: number

    /**
     * 
     * @type {number}
     * @memberof MealPlanApiAppApiMealPlanPostConfirmIngredientSwap
     */
    readonly meal_plan_id: number

    /**
     * 
     * @type {ConfirmIngredientSwapRequest}
     * @memberof MealPlanApiAppApiMealPlanPostConfirmIngredientSwap
     */
    readonly ConfirmIngredientSwapRequest: ConfirmIngredientSwapRequest
}

/**
 * Request parameters for appApiMealPlanPostDuplicateMealPlan operation in MealPlanApi.
 * @export
 * @interface MealPlanApiAppApiMealPlanPostDuplicateMealPlanRequest
 */
export interface MealPlanApiAppApiMealPlanPostDuplicateMealPlanRequest {
    /**
     * 
     * @type {number}
     * @memberof MealPlanApiAppApiMealPlanPostDuplicateMealPlan
     */
    readonly patient_id: number

    /**
     * 
     * @type {number}
     * @memberof MealPlanApiAppApiMealPlanPostDuplicateMealPlan
     */
    readonly meal_plan_id: number
}

/**
 * Request parameters for appApiMealPlanPostEmailMealPlan operation in MealPlanApi.
 * @export
 * @interface MealPlanApiAppApiMealPlanPostEmailMealPlanRequest
 */
export interface MealPlanApiAppApiMealPlanPostEmailMealPlanRequest {
    /**
     * 
     * @type {number}
     * @memberof MealPlanApiAppApiMealPlanPostEmailMealPlan
     */
    readonly patient_id: number

    /**
     * 
     * @type {number}
     * @memberof MealPlanApiAppApiMealPlanPostEmailMealPlan
     */
    readonly meal_plan_id: number

    /**
     * 
     * @type {EmailMealPlanRequest}
     * @memberof MealPlanApiAppApiMealPlanPostEmailMealPlan
     */
    readonly EmailMealPlanRequest?: EmailMealPlanRequest
}

/**
 * Request parameters for appApiMealPlanPostFinalizeMealPlan operation in MealPlanApi.
 * @export
 * @interface MealPlanApiAppApiMealPlanPostFinalizeMealPlanRequest
 */
export interface MealPlanApiAppApiMealPlanPostFinalizeMealPlanRequest {
    /**
     * 
     * @type {number}
     * @memberof MealPlanApiAppApiMealPlanPostFinalizeMealPlan
     */
    readonly patient_id: number

    /**
     * 
     * @type {number}
     * @memberof MealPlanApiAppApiMealPlanPostFinalizeMealPlan
     */
    readonly meal_plan_id: number
}

/**
 * Request parameters for appApiMealPlanPostGenerateMealPlan operation in MealPlanApi.
 * @export
 * @interface MealPlanApiAppApiMealPlanPostGenerateMealPlanRequest
 */
export interface MealPlanApiAppApiMealPlanPostGenerateMealPlanRequest {
    /**
     * 
     * @type {number}
     * @memberof MealPlanApiAppApiMealPlanPostGenerateMealPlan
     */
    readonly patient_id: number

    /**
     * 
     * @type {number}
     * @memberof MealPlanApiAppApiMealPlanPostGenerateMealPlan
     */
    readonly meal_plan_id: number
}

/**
 * Request parameters for appApiMealPlanPostGroceryList operation in MealPlanApi.
 * @export
 * @interface MealPlanApiAppApiMealPlanPostGroceryListRequest
 */
export interface MealPlanApiAppApiMealPlanPostGroceryListRequest {
    /**
     * 
     * @type {number}
     * @memberof MealPlanApiAppApiMealPlanPostGroceryList
     */
    readonly patient_id: number

    /**
     * 
     * @type {number}
     * @memberof MealPlanApiAppApiMealPlanPostGroceryList
     */
    readonly meal_plan_id: number
}

/**
 * Request parameters for appApiMealPlanPostMealPlan operation in MealPlanApi.
 * @export
 * @interface MealPlanApiAppApiMealPlanPostMealPlanRequest
 */
export interface MealPlanApiAppApiMealPlanPostMealPlanRequest {
    /**
     * 
     * @type {number}
     * @memberof MealPlanApiAppApiMealPlanPostMealPlan
     */
    readonly patient_id: number

    /**
     * 
     * @type {CreateMealPlanRequest}
     * @memberof MealPlanApiAppApiMealPlanPostMealPlan
     */
    readonly CreateMealPlanRequest: CreateMealPlanRequest
}

/**
 * Request parameters for appApiMealPlanPostMealPlanPdf operation in MealPlanApi.
 * @export
 * @interface MealPlanApiAppApiMealPlanPostMealPlanPdfRequest
 */
export interface MealPlanApiAppApiMealPlanPostMealPlanPdfRequest {
    /**
     * 
     * @type {number}
     * @memberof MealPlanApiAppApiMealPlanPostMealPlanPdf
     */
    readonly patient_id: number

    /**
     * 
     * @type {number}
     * @memberof MealPlanApiAppApiMealPlanPostMealPlanPdf
     */
    readonly meal_plan_id: number
}

/**
 * Request parameters for appApiMealPlanPostSlotNote operation in MealPlanApi.
 * @export
 * @interface MealPlanApiAppApiMealPlanPostSlotNoteRequest
 */
export interface MealPlanApiAppApiMealPlanPostSlotNoteRequest {
    /**
     * 
     * @type {number}
     * @memberof MealPlanApiAppApiMealPlanPostSlotNote
     */
    readonly patient_id: number

    /**
     * 
     * @type {number}
     * @memberof MealPlanApiAppApiMealPlanPostSlotNote
     */
    readonly meal_plan_id: number

    /**
     * 
     * @type {number}
     * @memberof MealPlanApiAppApiMealPlanPostSlotNote
     */
    readonly slot_id: number

    /**
     * 
     * @type {AppApiMealPlanPostSlotNoteRequest}
     * @memberof MealPlanApiAppApiMealPlanPostSlotNote
     */
    readonly AppApiMealPlanPostSlotNoteRequest: AppApiMealPlanPostSlotNoteRequest
}

/**
 * Request parameters for appApiMealPlanPostSwapConfirm operation in MealPlanApi.
 * @export
 * @interface MealPlanApiAppApiMealPlanPostSwapConfirmRequest
 */
export interface MealPlanApiAppApiMealPlanPostSwapConfirmRequest {
    /**
     * 
     * @type {number}
     * @memberof MealPlanApiAppApiMealPlanPostSwapConfirm
     */
    readonly patient_id: number

    /**
     * 
     * @type {number}
     * @memberof MealPlanApiAppApiMealPlanPostSwapConfirm
     */
    readonly meal_plan_id: number

    /**
     * 
     * @type {SwapConfirmRequest}
     * @memberof MealPlanApiAppApiMealPlanPostSwapConfirm
     */
    readonly SwapConfirmRequest: SwapConfirmRequest
}

/**
 * Request parameters for appApiMealPlanPostSwapIngredient operation in MealPlanApi.
 * @export
 * @interface MealPlanApiAppApiMealPlanPostSwapIngredientRequest
 */
export interface MealPlanApiAppApiMealPlanPostSwapIngredientRequest {
    /**
     * 
     * @type {number}
     * @memberof MealPlanApiAppApiMealPlanPostSwapIngredient
     */
    readonly patient_id: number

    /**
     * 
     * @type {number}
     * @memberof MealPlanApiAppApiMealPlanPostSwapIngredient
     */
    readonly meal_plan_id: number

    /**
     * 
     * @type {SwapIngredientRequest}
     * @memberof MealPlanApiAppApiMealPlanPostSwapIngredient
     */
    readonly SwapIngredientRequest: SwapIngredientRequest
}

/**
 * Request parameters for appApiMealPlanPostSwapRecipe operation in MealPlanApi.
 * @export
 * @interface MealPlanApiAppApiMealPlanPostSwapRecipeRequest
 */
export interface MealPlanApiAppApiMealPlanPostSwapRecipeRequest {
    /**
     * 
     * @type {number}
     * @memberof MealPlanApiAppApiMealPlanPostSwapRecipe
     */
    readonly patient_id: number

    /**
     * 
     * @type {number}
     * @memberof MealPlanApiAppApiMealPlanPostSwapRecipe
     */
    readonly meal_plan_id: number

    /**
     * 
     * @type {SwapRecipeRequest}
     * @memberof MealPlanApiAppApiMealPlanPostSwapRecipe
     */
    readonly SwapRecipeRequest: SwapRecipeRequest
}

/**
 * Request parameters for appApiMealPlanPostSwapSuggestions operation in MealPlanApi.
 * @export
 * @interface MealPlanApiAppApiMealPlanPostSwapSuggestionsRequest
 */
export interface MealPlanApiAppApiMealPlanPostSwapSuggestionsRequest {
    /**
     * 
     * @type {number}
     * @memberof MealPlanApiAppApiMealPlanPostSwapSuggestions
     */
    readonly patient_id: number

    /**
     * 
     * @type {number}
     * @memberof MealPlanApiAppApiMealPlanPostSwapSuggestions
     */
    readonly meal_plan_id: number

    /**
     * 
     * @type {SwapSuggestionsRequest}
     * @memberof MealPlanApiAppApiMealPlanPostSwapSuggestions
     */
    readonly SwapSuggestionsRequest: SwapSuggestionsRequest
}

/**
 * Request parameters for appApiMealPlanPostTdeeCalculate operation in MealPlanApi.
 * @export
 * @interface MealPlanApiAppApiMealPlanPostTdeeCalculateRequest
 */
export interface MealPlanApiAppApiMealPlanPostTdeeCalculateRequest {
    /**
     * 
     * @type {number}
     * @memberof MealPlanApiAppApiMealPlanPostTdeeCalculate
     */
    readonly patient_id: number

    /**
     * 
     * @type {TdeeCalculateRequest}
     * @memberof MealPlanApiAppApiMealPlanPostTdeeCalculate
     */
    readonly TdeeCalculateRequest: TdeeCalculateRequest
}

/**
 * Request parameters for appApiMealPlanPutClinicMealPlanSettings operation in MealPlanApi.
 * @export
 * @interface MealPlanApiAppApiMealPlanPutClinicMealPlanSettingsRequest
 */
export interface MealPlanApiAppApiMealPlanPutClinicMealPlanSettingsRequest {
    /**
     * 
     * @type {number}
     * @memberof MealPlanApiAppApiMealPlanPutClinicMealPlanSettings
     */
    readonly clinic_id: number

    /**
     * 
     * @type {ClinicMealPlanSettingsRequest}
     * @memberof MealPlanApiAppApiMealPlanPutClinicMealPlanSettings
     */
    readonly ClinicMealPlanSettingsRequest: ClinicMealPlanSettingsRequest
}

/**
 * MealPlanApi - object-oriented interface
 * @export
 * @class MealPlanApi
 * @extends {BaseAPI}
 */
export class MealPlanApi extends BaseAPI {
    /**
     * 
     * @summary Soft-delete a meal plan
     * @param {MealPlanApiAppApiMealPlanDeleteMealPlanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MealPlanApi
     */
    public appApiMealPlanDeleteMealPlan(requestParameters: MealPlanApiAppApiMealPlanDeleteMealPlanRequest, options?: AxiosRequestConfig) {
        return MealPlanApiFp(this.configuration).appApiMealPlanDeleteMealPlan(requestParameters.patient_id, requestParameters.meal_plan_id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get meal plan settings for a clinic
     * @param {MealPlanApiAppApiMealPlanGetClinicMealPlanSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MealPlanApi
     */
    public appApiMealPlanGetClinicMealPlanSettings(requestParameters: MealPlanApiAppApiMealPlanGetClinicMealPlanSettingsRequest, options?: AxiosRequestConfig) {
        return MealPlanApiFp(this.configuration).appApiMealPlanGetClinicMealPlanSettings(requestParameters.clinic_id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a specific meal plan with days and slots
     * @param {MealPlanApiAppApiMealPlanGetMealPlanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MealPlanApi
     */
    public appApiMealPlanGetMealPlan(requestParameters: MealPlanApiAppApiMealPlanGetMealPlanRequest, options?: AxiosRequestConfig) {
        return MealPlanApiFp(this.configuration).appApiMealPlanGetMealPlan(requestParameters.patient_id, requestParameters.meal_plan_id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List meal plans for the patient
     * @param {MealPlanApiAppApiMealPlanGetMealPlansRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MealPlanApi
     */
    public appApiMealPlanGetMealPlans(requestParameters: MealPlanApiAppApiMealPlanGetMealPlansRequest, options?: AxiosRequestConfig) {
        return MealPlanApiFp(this.configuration).appApiMealPlanGetMealPlans(requestParameters.patient_id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get recipe instructions for a meal plan slot
     * @param {MealPlanApiAppApiMealPlanGetSlotInstructionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MealPlanApi
     */
    public appApiMealPlanGetSlotInstructions(requestParameters: MealPlanApiAppApiMealPlanGetSlotInstructionsRequest, options?: AxiosRequestConfig) {
        return MealPlanApiFp(this.configuration).appApiMealPlanGetSlotInstructions(requestParameters.patient_id, requestParameters.meal_plan_id, requestParameters.slot_id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Confirm an ingredient swap in a meal plan slot
     * @param {MealPlanApiAppApiMealPlanPostConfirmIngredientSwapRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MealPlanApi
     */
    public appApiMealPlanPostConfirmIngredientSwap(requestParameters: MealPlanApiAppApiMealPlanPostConfirmIngredientSwapRequest, options?: AxiosRequestConfig) {
        return MealPlanApiFp(this.configuration).appApiMealPlanPostConfirmIngredientSwap(requestParameters.patient_id, requestParameters.meal_plan_id, requestParameters.ConfirmIngredientSwapRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Duplicate a meal plan as a new draft
     * @param {MealPlanApiAppApiMealPlanPostDuplicateMealPlanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MealPlanApi
     */
    public appApiMealPlanPostDuplicateMealPlan(requestParameters: MealPlanApiAppApiMealPlanPostDuplicateMealPlanRequest, options?: AxiosRequestConfig) {
        return MealPlanApiFp(this.configuration).appApiMealPlanPostDuplicateMealPlan(requestParameters.patient_id, requestParameters.meal_plan_id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Email a meal plan to the patient
     * @param {MealPlanApiAppApiMealPlanPostEmailMealPlanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MealPlanApi
     */
    public appApiMealPlanPostEmailMealPlan(requestParameters: MealPlanApiAppApiMealPlanPostEmailMealPlanRequest, options?: AxiosRequestConfig) {
        return MealPlanApiFp(this.configuration).appApiMealPlanPostEmailMealPlan(requestParameters.patient_id, requestParameters.meal_plan_id, requestParameters.EmailMealPlanRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Finalize a generated meal plan
     * @param {MealPlanApiAppApiMealPlanPostFinalizeMealPlanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MealPlanApi
     */
    public appApiMealPlanPostFinalizeMealPlan(requestParameters: MealPlanApiAppApiMealPlanPostFinalizeMealPlanRequest, options?: AxiosRequestConfig) {
        return MealPlanApiFp(this.configuration).appApiMealPlanPostFinalizeMealPlan(requestParameters.patient_id, requestParameters.meal_plan_id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generate meal plan content using AI
     * @param {MealPlanApiAppApiMealPlanPostGenerateMealPlanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MealPlanApi
     */
    public appApiMealPlanPostGenerateMealPlan(requestParameters: MealPlanApiAppApiMealPlanPostGenerateMealPlanRequest, options?: AxiosRequestConfig) {
        return MealPlanApiFp(this.configuration).appApiMealPlanPostGenerateMealPlan(requestParameters.patient_id, requestParameters.meal_plan_id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generate a grocery list for a meal plan
     * @param {MealPlanApiAppApiMealPlanPostGroceryListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MealPlanApi
     */
    public appApiMealPlanPostGroceryList(requestParameters: MealPlanApiAppApiMealPlanPostGroceryListRequest, options?: AxiosRequestConfig) {
        return MealPlanApiFp(this.configuration).appApiMealPlanPostGroceryList(requestParameters.patient_id, requestParameters.meal_plan_id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new meal plan for the patient
     * @param {MealPlanApiAppApiMealPlanPostMealPlanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MealPlanApi
     */
    public appApiMealPlanPostMealPlan(requestParameters: MealPlanApiAppApiMealPlanPostMealPlanRequest, options?: AxiosRequestConfig) {
        return MealPlanApiFp(this.configuration).appApiMealPlanPostMealPlan(requestParameters.patient_id, requestParameters.CreateMealPlanRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generate a PDF for a meal plan
     * @param {MealPlanApiAppApiMealPlanPostMealPlanPdfRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MealPlanApi
     */
    public appApiMealPlanPostMealPlanPdf(requestParameters: MealPlanApiAppApiMealPlanPostMealPlanPdfRequest, options?: AxiosRequestConfig) {
        return MealPlanApiFp(this.configuration).appApiMealPlanPostMealPlanPdf(requestParameters.patient_id, requestParameters.meal_plan_id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add or update a clinician note on a meal plan slot
     * @param {MealPlanApiAppApiMealPlanPostSlotNoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MealPlanApi
     */
    public appApiMealPlanPostSlotNote(requestParameters: MealPlanApiAppApiMealPlanPostSlotNoteRequest, options?: AxiosRequestConfig) {
        return MealPlanApiFp(this.configuration).appApiMealPlanPostSlotNote(requestParameters.patient_id, requestParameters.meal_plan_id, requestParameters.slot_id, requestParameters.AppApiMealPlanPostSlotNoteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Confirm a recipe swap in a meal plan slot
     * @param {MealPlanApiAppApiMealPlanPostSwapConfirmRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MealPlanApi
     */
    public appApiMealPlanPostSwapConfirm(requestParameters: MealPlanApiAppApiMealPlanPostSwapConfirmRequest, options?: AxiosRequestConfig) {
        return MealPlanApiFp(this.configuration).appApiMealPlanPostSwapConfirm(requestParameters.patient_id, requestParameters.meal_plan_id, requestParameters.SwapConfirmRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get ingredient swap suggestions for a meal plan slot
     * @param {MealPlanApiAppApiMealPlanPostSwapIngredientRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MealPlanApi
     */
    public appApiMealPlanPostSwapIngredient(requestParameters: MealPlanApiAppApiMealPlanPostSwapIngredientRequest, options?: AxiosRequestConfig) {
        return MealPlanApiFp(this.configuration).appApiMealPlanPostSwapIngredient(requestParameters.patient_id, requestParameters.meal_plan_id, requestParameters.SwapIngredientRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Swap a recipe in a meal plan slot
     * @param {MealPlanApiAppApiMealPlanPostSwapRecipeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MealPlanApi
     */
    public appApiMealPlanPostSwapRecipe(requestParameters: MealPlanApiAppApiMealPlanPostSwapRecipeRequest, options?: AxiosRequestConfig) {
        return MealPlanApiFp(this.configuration).appApiMealPlanPostSwapRecipe(requestParameters.patient_id, requestParameters.meal_plan_id, requestParameters.SwapRecipeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get swap recipe suggestions for a meal plan slot
     * @param {MealPlanApiAppApiMealPlanPostSwapSuggestionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MealPlanApi
     */
    public appApiMealPlanPostSwapSuggestions(requestParameters: MealPlanApiAppApiMealPlanPostSwapSuggestionsRequest, options?: AxiosRequestConfig) {
        return MealPlanApiFp(this.configuration).appApiMealPlanPostSwapSuggestions(requestParameters.patient_id, requestParameters.meal_plan_id, requestParameters.SwapSuggestionsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Calculate TDEE for a patient
     * @param {MealPlanApiAppApiMealPlanPostTdeeCalculateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MealPlanApi
     */
    public appApiMealPlanPostTdeeCalculate(requestParameters: MealPlanApiAppApiMealPlanPostTdeeCalculateRequest, options?: AxiosRequestConfig) {
        return MealPlanApiFp(this.configuration).appApiMealPlanPostTdeeCalculate(requestParameters.patient_id, requestParameters.TdeeCalculateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update meal plan settings for a clinic
     * @param {MealPlanApiAppApiMealPlanPutClinicMealPlanSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MealPlanApi
     */
    public appApiMealPlanPutClinicMealPlanSettings(requestParameters: MealPlanApiAppApiMealPlanPutClinicMealPlanSettingsRequest, options?: AxiosRequestConfig) {
        return MealPlanApiFp(this.configuration).appApiMealPlanPutClinicMealPlanSettings(requestParameters.clinic_id, requestParameters.ClinicMealPlanSettingsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

